/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { assertDeclareTypeAlias } from '@babel/types'
import { AxiosResponse } from 'axios'
import hosts from 'config/microServices'
import QueryStringFilter from 'Helpers/QueryStringFilter'
import {
  IAlertaOcorrencia,
  IAlertaJustificativa,
  IAlertaTipo,
} from 'Models/docas'
import IAlertaTipoConfiguracao from 'Models/docas/IAlertaTipoConfiguracao'
import ApiService from 'Services/ApiService'
import {
  ServiceCreateResponse,
  ServiceListResponse,
  ServiceUpdateResponse,
} from 'Types/ServiceResponse'

const alerta = {
  getList: async (idComponente: number, cdAgendamentoDocasHorario: number) => {
    const result: AxiosResponse<ServiceListResponse<IAlertaOcorrencia>> =
      await ApiService({ idComponente }).get<
        ServiceListResponse<IAlertaTipoConfiguracao>
      >(
        QueryStringFilter(`${hosts.WS_DOCAS}/alerta`, {
          cdAgendamentoDocasHorario,
        }),
      )

    return result
  },

  justify: async (
    idComponente: number,
    alertaJustificativa: IAlertaJustificativa,
  ) => {
    const result: AxiosResponse<ServiceCreateResponse> = await ApiService({
      idComponente,
    }).post<ServiceCreateResponse>(
      `${hosts.WS_DOCAS}/alerta_justificativa`,
      alertaJustificativa,
    )

    return result
  },

  getListConfiguracao: async (
    idComponente: number,
    cdEntidadeSistema: number,
  ) => {
    const result: AxiosResponse<ServiceListResponse<IAlertaTipoConfiguracao>> =
      await ApiService({ idComponente }).get<
        ServiceListResponse<IAlertaTipoConfiguracao>
      >(
        QueryStringFilter(`${hosts.WS_DOCAS}/alerta_tipo_configuracao`, {
          cdEntidadeSistema,
        }),
      )

    return result
  },

  createConfiguracao: async (
    idComponente: number,
    alerta: IAlertaTipoConfiguracao,
  ) => {
    const result: AxiosResponse<ServiceCreateResponse> = await ApiService({
      idComponente,
    }).post<ServiceCreateResponse>(
      `${hosts.WS_DOCAS}/alerta_tipo_configuracao`,
      alerta,
    )

    return result
  },

  updateConfiguracao: async (
    idComponente: number,
    cdAlertaTipoConfiguracao: number,
    tempo: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(
      `${hosts.WS_DOCAS}/ativar_desativar_alerta_tipo_configuracao`,
      { cdAlertaTipoConfiguracao, tempo },
    )

    return result
  },

  ativaDesativaConfiguracao: async (
    idComponente: number,
    cdAlertaTipoConfiguracao: number,
  ) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(
      `${hosts.WS_DOCAS}/ativar_desativar_alerta_tipo_configuracao`,
      { cdAlertaTipoConfiguracao },
    )

    return result
  },

  getListTipo: async (idComponente: number) => {
    const result: AxiosResponse<ServiceListResponse<IAlertaTipo>> =
      await ApiService({ idComponente }).get<
        ServiceListResponse<IAlertaTipoConfiguracao>
      >(QueryStringFilter(`${hosts.WS_DOCAS}/alerta_tipo`))

    return result
  },

  createTipo: async (idComponente: number, alerta: IAlertaTipo) => {
    const result: AxiosResponse<ServiceCreateResponse> = await ApiService({
      idComponente,
    }).post<ServiceCreateResponse>(`${hosts.WS_DOCAS}/alerta_tipo`, alerta)

    return result
  },

  updateTipo: async (idComponente: number, alerta: IAlertaTipo) => {
    const result: AxiosResponse<ServiceUpdateResponse> = await ApiService({
      idComponente,
    }).put<ServiceUpdateResponse>(`${hosts.WS_DOCAS}/alerta_tipo`, alerta)

    return result
  },

  deleteTipo: async (idComponente: number, id: number) => {
    const result: AxiosResponse<ServiceListResponse> = await ApiService({
      idComponente,
    }).delete<ServiceListResponse>(
      QueryStringFilter(`${hosts.WS_DOCAS}/alerta_tipo/${id}`),
      {},
    )

    return result
  },
}

export default alerta
